import BaseServiceCrud from './BaseServiceCrud';

export default class QuizService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'quiz-manage';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            hide_expired: criteria.hideExpired,
            locale: criteria.locale,
            text: criteria.text,
            description: criteria.description,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    get(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element, lang, quizId) {
        return this.fetch(`${this.domain}/${this.path}/${lang}/${quizId}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    
    completeQuiz(id) {
        return this.fetch(`${this.domain}/${this.path}/complete/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    removeQuiz(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publishToCompanies(id, request) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}/companies`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getSurveryAnswersUsersCount(id){
        return this.fetch(`${this.domain}/${this.path}/survey/${id}/answer-user-count`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
